export default {
    PIPELINE_LIST_REQUEST : "PIPELINE_LIST_REQUEST",
    PIPELINE_LIST_SUCCESS : "PIPELINE_LIST_SUCCESS",
    FILTER_PIPELINE_PAGINATION : "FILTER_PIPELINE_PAGINATION",
    SOURCE_DASH_LIST_REQUEST: "SOURCE_DASH_LIST_REQUEST",
    SOURCE_DASH_LIST_SUCCESS: "SOURCE_DASH_LIST_SUCCESS"
}